import domToReact from '../lib/dom-to-react.js';

export default domToReact.default || domToReact;
